import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-mod-2',
  templateUrl: './mod-2.component.html'
})
export class Mod2Component implements OnInit {
  @Input() public pictures: any;

  constructor() { }

  ngOnInit() {
  }

  getImageByPosition(type) {
    for (let i = 0; i < this.pictures.length; i++) {
      if(this.pictures[i].position == type) {
        return this.pictures[i];
      }
    }
  }

}



// WEBPACK FOOTER //
// /home3/usalinks/public_html/ally-book-source/src/app/media/mod-2/mod-2.component.ts